import { CompanyInfoResponse } from '../../generated/api/companyInfoResponse';
import { addEmptyFieldValidationError } from '../../common/utils/errorUtils';
import { fieldCantBeEmptyMsg, t } from '../../common/i18n';
import type { CommonError } from '../../common/types/errors';
import type { ContactPerson } from '../../generated/api/contactPerson';

export function getErrorsFromUpdateUserDetails(
  user: ContactPerson,
  customerType?: CompanyInfoResponse.CustomerTypeEnum,
  validationErrors?: CommonError[]
): CommonError[] | undefined {
  const errors: CommonError[] = [];
  if (user) {
    if (customerType === CompanyInfoResponse.CustomerTypeEnum.INTERNAL_CUSTOMERS && !user.costCenter) {
      addEmptyFieldValidationError(errors, 'costCenter', t.VPVR(fieldCantBeEmptyMsg));
    }
    if (!user.email?.length) {
      addEmptyFieldValidationError(errors, 'email', t.VPVR(fieldCantBeEmptyMsg));
    }
    if (!user.firstName?.trim().length) {
      addEmptyFieldValidationError(errors, 'firstName', t.VPVR(fieldCantBeEmptyMsg));
    }
    if (!user.lastName?.trim().length) {
      addEmptyFieldValidationError(errors, 'lastName', t.VPVR(fieldCantBeEmptyMsg));
    }
    if (!user.phoneNumber?.length) {
      addEmptyFieldValidationError(errors, 'phoneNumber', t.VPVR(fieldCantBeEmptyMsg));
    }
  }
  if (errors.length === 0) {
    return validationErrors;
  }
  return errors.concat(validationErrors || []);
}
